import { FC } from 'react';

import { NodeStatus, zNodeStatus } from '@dbt-labs/dbt-dag';
import { CellContext, Tooltip } from '@dbt-labs/sourdough';

import { FreshnessStatus } from '@/__generated__/graphql';
import { NodeStatusIconBadge } from '@/components/NodeStatusIconBadge';

type NodeStatusValue = FreshnessStatus | NodeStatus | undefined;
type NodeStatusCellProps = CellContext<any, NodeStatusValue>;

export const NodeStatusCell: FC<NodeStatusCellProps> = ({ getValue }) => {
  const value = getValue()?.toLowerCase();
  const status = zNodeStatus.safeParse(value as any).success
    ? (value as NodeStatus)
    : 'not available';
  return (
    <Tooltip displayOnlyWhenTruncated content={status}>
      {(ref) => (
        <div ref={ref} className="truncate text-fgBrand underline">
          <NodeStatusIconBadge
            status={status ?? 'not available'}
            size="small"
            className="w-full"
          />
        </div>
      )}
    </Tooltip>
  );
};
